// Namespaces
wfx = wfx || {};
wfx.ui = wfx.ui || {};
wfx.ready = wfx.ready || [];

wfx.ui.Register = function ($cont) {
    let priv = {},
        that = {};

    priv.$cont = $cont;
    priv.$telephone = $cont.find('#telephone');
    priv.$birthday = $cont.find('#birthday');
    priv.$customerExistsYes = $('.js-customer_exists_yes');
    priv.$customerExistsNo = $('.js-customer_exists_no');

    priv.init = function () {
        if (priv.$telephone.length) {
            priv.telephoneStep();
        }
        else if(priv.$customerExistsYes.length) {
            priv.agentStep();
        }
    }

    priv.telephoneStep = function () {
        priv.$birthday.focus(function () {
            $(this).attr('placeholder', '__.__.____')
        });

        priv.$birthday.blur(function () {
            $(this).attr('placeholder', 'Geburtsdatum*')
        });

        const input = document.querySelector("#telephone");
        window.IntlTelInput(input, {
            // any initialisation options go here
            initialCountry: "at",
            onlyCountries: ["at"],
            allowDropdown: false,
            localizedCountries: {
                'at': 'Österreich'
            },
        });

        $cont.find('#telephone').change(function () {
            $(this).val(priv.addCountryCode($(this)));
        });
 
        priv.$telephone.val(priv.addCountryCode(priv.$telephone));
    }

    priv.addCountryCode = function ($telephone) {
        if ($telephone.val().startsWith('0')) {
            var tel = $telephone.val();
            tel = '+43' + tel.substr(1);
            tel = tel.replace(/\s/g, "");
            return tel;
        }
        else if (!$telephone.val().startsWith('+43') && $telephone.val()) {
            return '+43' + $telephone.val();
        }
        return $telephone.val()
    }

    priv.agentStep = function () {

        priv.$customerExistsYes.on('click', function () {
            var $this = $(this);
            var $noBtn = $('.js-customer_no');
            var $yesBtn = $('.js-customer_yes');

            if (priv.$customerExistsNo.hasClass('btn-primary')) {
                priv.$customerExistsNo.removeClass('btn-primary');
                priv.$customerExistsNo.addClass('btn-outline-primary');
                $noBtn.hide();
            }

            if ($this.hasClass('btn-primary')) {
                $this.addClass('btn-outline-primary');
                $this.removeClass('btn-primary');

                $yesBtn.hide();
            }
            else {
                $this.removeClass('btn-outline-primary');
                $this.addClass('btn-primary');

                $yesBtn.show();
            }

        });

        priv.$customerExistsNo.on('click', function () {
            var $this = $(this);
            var $noBtn = $('.js-customer_no');
            var $yesBtn = $('.js-customer_yes');

            if (priv.$customerExistsYes.hasClass('btn-primary')) {
                priv.$customerExistsYes.removeClass('btn-primary');
                priv.$customerExistsYes.addClass('btn-outline-primary');

                $yesBtn.hide();
            }

            if ($this.hasClass('btn-primary')) {
                $this.addClass('btn-outline-primary');
                $this.removeClass('btn-primary');
                $noBtn.hide();
            }
            else {
                $this.removeClass('btn-outline-primary');
                $this.addClass('btn-primary');
                $noBtn.show();
            }

        });

        $('.postalCode').on('keypress', function (evt) {
            var $this = $(this);

            if($this.val().length >= 4) {
                return false;
            }

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        });

        $('.js-submit_form').on('click', function () {
            var $radioBtn = $('input[name="noChoice1"]:checked');
            var clientToken = $('.clientToken').val();
            var $this = $(this);

            if($radioBtn) {
                if($radioBtn.val() == 1) {
                    var postalCode = $('.clientPostalCode').val();
                    var urlParameterPostalCode = '';
                    if (postalCode) {
                        urlParameterPostalCode = '&postalCode='+postalCode;
                    }

                    $this.attr('disabled', 'true');

                    window.location.href = '/register/'+clientToken+'/agent/search?existingClient=0'+urlParameterPostalCode;
                }
                else if($radioBtn.val() == 2) {
                    $this.attr('disabled', 'true');
                    window.location.href = '/register/'+clientToken+'/agent/selected?agent=wefox_direct&existingClient=0';
                }
            }
        });
    }

    priv.init();
}
